import angular from 'angular';
import * as _ from 'lodash';
import Logger from '../../../shared/logger';

const EmployersRepCache = {};

export class EmployerRep {
    static getName = (employerRep) => employerRep.name
    static getEmail = (employerRep) => employerRep.email
}

export const EmployerRepService = (Restangular) => {
    const createEmployersRep = function (data) {
        return Restangular.all('employerRep')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getExistingEmployerRep = function (id) {
        return Restangular.one('employerRep', id)
            .get('')
            .catch(error => Logger.error(error));
    };

    const updateExistingEmployerRep = function (id, data) {
        return Restangular.one('employerRep', id)
            .customPUT(data)
            .catch(error => Logger.error(error));
    };

    const activateExistingEmployerRep = function (id, data) {
        return Restangular.one('employerRep', id)
            .all('activate')
            .customPUT(data)
            .catch(error => Logger.error(error));
    };

    const activateNewEmployerRep = function (id, data) {
        return Restangular.one('employerRep', id)
            .all('activateNew')
            .customPUT(data)
            .catch(error => Logger.error(error));
    };

    const activateLinkedinEmployerRep = function (id, data) {
        return Restangular.one('employerRep', id)
            .all('activate-linkedin')
            .customPOST(data)
            .catch(error => Logger.error(error));
    };

    const getEmployersRepSearch = function (data) {
        return Restangular.all('employerRep')
            .all('search')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getEmployersRepsByIds = ({ employerRepIds }) => {
        if (!_.isArray(employerRepIds) || !employerRepIds.length) {
            return [];
        }

        if (employerRepIds && employerRepIds.length === 1) {
            const emplId = _.first(employerRepIds);

            if (!EmployersRepCache[emplId]) {
                EmployersRepCache[emplId] = Restangular.all('employerRep')
                    .all('search')
                    .post({ employerRepIDs: [emplId] })
                    .catch(error => Logger.error(error));
            }

            return EmployersRepCache[emplId];
        } else {
            return Restangular.all('employerRep')
                .all('search')
                .post({employerRepIDs: employerRepIds})
                .catch(error => Logger.error(error));
        }

    };

    const getEmployersRepSearchByEmail = function (data) {
        return Restangular.all('employerRep')
            .all('searchByEmail')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const deactivateExistingEmployerRep = function (id, data) {
        return Restangular.one('employerRep', id)
            .all('deactivate')
            .customPUT(data)
            .catch(error => Logger.error(error));
    };

    const sendInivitationToEmployerRep = function (data) {
        return Restangular.all('employerRep')
            .all('sendInvitation')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const addEmployerRepToSystem = function (employerRepId, data) {
        return Restangular.one('employerRep', employerRepId)
            .all('addToSystem')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const getEmployerRepDetails = function (employerRepId) {
        return Restangular.one('employerRep', employerRepId)
            .all('details')
            .get('')
            .catch(error => Logger.error(error));
    };

    const getEmployerRepByInvitationId = function (invitationId) {
        return Restangular.all('employerRep')
            .one('byInvitation', invitationId)
            .get('')
            .catch(error => Logger.error(error));
    };

    const getAuthenticationActionForEmployerFeedback = function (data) {
        return Restangular.all('employerRep')
            .all('authenticationActionForEmployerFeedback')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const confirmEmail = function (data) {
        return Restangular.all('employerRep')
            .all('confirmEmail')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const systemSignUpEmployerRep = function (data) {
        return Restangular.all('employerRep')
            .all('systemSignUp')
            .post(data)
            .catch(error => Logger.error(error));
    };

    const updateEmployerRepRoles = (employerRepId, rolesActions) => {
        return Restangular.one('employerRep', employerRepId)
            .all('roles')
            .customPUT(rolesActions)
            .catch(error => Logger.error(error));
    };

    return {
        createEmployersRep,
        getExistingEmployerRep,
        updateExistingEmployerRep,
        getEmployersRepSearch,
        getEmployersRepsByIds,
        getEmployersRepSearchByEmail,
        activateExistingEmployerRep,
        activateNewEmployerRep,
        activateLinkedinEmployerRep,
        deactivateExistingEmployerRep,
        sendInivitationToEmployerRep,
        addEmployerRepToSystem,
        getEmployerRepDetails,
        getAuthenticationActionForEmployerFeedback,
        confirmEmail,
        updateEmployerRepRoles,
        systemSignUpEmployerRep,
        getEmployerRepByInvitationId,
    };
};

angular
    .module('TALENYA-FE')
    .factory('EmployerRepService', EmployerRepService);
